// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import inquiryEntity from './entities/inquiry.json';
import inquiryMenu from '../pages/inquiry/menu.json';
import inquiryFullForm from '../pages/inquiry/forms/full.json';
import inquiryContextForm from '../pages/inquiry/forms/context.json';
import inquiryMiniForm from '../pages/inquiry/forms/mini.json';
import inquiryLookupForm from '../pages/inquiry/forms/lookup.json';
import inquiryTableView from '../pages/inquiry/views/table.json';
import inquiryStagesView from '../pages/inquiry/views/stages.json';
import inquiryCardsView from '../pages/inquiry/views/cards.json';
import inquiryInlineView from '../pages/inquiry/views/inline.json';
import inquiryBacklogView from '../pages/inquiry/views/backlog.json';
import inquirySplitView from '../pages/inquiry/views/split.json';
import inquiryCalendarView from '../pages/inquiry/views/calendar.json';
import inquiryDashboardView from '../pages/inquiry/views/dashboard.json';

/** Тип запису «Запит» зі сторінками пакета: меню, форми та подання з pages/inquiry/. */
export const inquiryDefinition: IRecordTypeDefinition = {
  ...inquiryEntity,
  views: assembleViewSet({
      table: inquiryTableView,
      stages: inquiryStagesView,
      cards: inquiryCardsView,
      inline: inquiryInlineView,
      backlog: inquiryBacklogView,
      split: inquirySplitView,
      calendar: inquiryCalendarView,
      dashboard: inquiryDashboardView,
  }),
  form: inquiryFullForm,
  forms: { full: inquiryFullForm, context: inquiryContextForm, mini: inquiryMiniForm, lookup: inquiryLookupForm },
  menu: inquiryMenu,
} as IRecordTypeDefinition;
